import {HealthIndicatorsApi, KilnInfo} from '@domain/kiln-monitoring'
import {Grid} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {KMS_WIDGET_NAMESPACE} from '../../consts'
import {KilnMetricStatus} from '../shared'

export const KilnMetricStatusGrid = ({
  isLoading,
  kilnInfo,
  healthIndicators,
  gridItemSettings
}: {
  isLoading: boolean
  kilnInfo?: KilnInfo | null
  healthIndicators?: HealthIndicatorsApi
  gridItemSettings: {
    xs: number
    md: number
    lg: number
  }
}) => {
  const {t} = useTranslation(KMS_WIDGET_NAMESPACE)

  return (
    <Grid
      direction="row"
      rowSpacing={1}
      columnSpacing={1}
      columns={{
        xs: 10,
        sm: 16,
        lg: 8
      }}
      container
      data-test-id="kiln-metric-statuses"
    >
      <Grid item {...gridItemSettings} data-test-id="kiln-metric-speed">
        <KilnMetricStatus
          title={t('kilnMetrics.speed')}
          value={`${healthIndicators?.speed?.value?.toFixed(1) ?? '-'} ${
            healthIndicators?.speed?.unit ?? ''
          }`}
          status={healthIndicators?.speed?.status}
          loading={isLoading}
          signals={kilnInfo?.layout?.speedSignals}
        />
      </Grid>
      <Grid item {...gridItemSettings} data-test-id="kiln-metric-feed">
        <KilnMetricStatus
          title={t('kilnMetrics.feed')}
          value={`${healthIndicators?.feed?.value?.toFixed(0) ?? '-'} ${
            healthIndicators?.feed?.unit ?? ''
          }`}
          status={healthIndicators?.feed?.status}
          loading={isLoading}
          signals={kilnInfo?.layout?.feedSignals}
        />
      </Grid>
      <Grid item {...gridItemSettings} data-test-id="kiln-metric-ovality">
        <KilnMetricStatus
          title={t('kilnMetrics.ovality')}
          loading={isLoading}
          status={healthIndicators?.ovality?.status}
          signals={kilnInfo?.layout?.ovalitySignals}
          disabled={!kilnInfo?.layout?.ovalitySignals?.length}
        />
      </Grid>
      <Grid item {...gridItemSettings} data-test-id="kiln-metric-axial-balance">
        <KilnMetricStatus title={t('kilnMetrics.axialBalance')} loading={isLoading} disabled />
      </Grid>
      <Grid item {...gridItemSettings} data-test-id="kiln-metric-warp">
        <KilnMetricStatus
          title={t('kilnMetrics.warp')}
          loading={isLoading}
          status={healthIndicators?.crank?.status}
          disabled={
            !kilnInfo?.layout?.crankSignals || !Object.keys(kilnInfo.layout.crankSignals).length
          }
          signals={kilnInfo?.layout?.crankSignals}
        />
      </Grid>
    </Grid>
  )
}
